// src/App.tsx

import { Routes, Route } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { Header } from './components/organisms/Header/Header'
import { Footer } from './components/organisms/Footer/Footer'
import { HeroSection } from './components/organisms/HeroSection/HeroSection'
import { ProjectsSection } from './components/organisms/ProjectSection/ProjectsSection'
import { SkillsSection } from './components/organisms/SkillsSection/SkillsSection'
import { GitHubSection } from './components/organisms/GitHubSection/GitHubSection'
import { BlogSection } from './components/organisms/BlogSection/BlogSection'
import { ContactPage } from './pages/ContactPage/ContactPage'
import { BlogPage } from './pages/BlogPage/BlogPage'
import { ArticleDetailPage } from './pages/ArticleDetailPage/ArticleDetailPage'
import { LoginPage } from './pages/LoginPage/LoginPage'
import { AccountPage } from './pages/AccountPage/AccountPage'
import { CreateArticlePage } from './pages/CreateArticlePage/CreateArticlePage'
import { EditArticlePage } from './pages/EditArticlePage/EditArticlePage'

// import './App.css'

/*
 * HomePage
 * ──────────────────────────────────────────────
 * Sections de la page d'accueil regroupées ici.
 * Rendues UNIQUEMENT sur la route "/" — elles
 * n'apparaissent pas sur /contact, /blog, etc.
 */
function HomePage() {
  return (
    <>
      <Helmet>
        <title>Steven YAMBOS — Développeur Back-End</title>
        <meta name="description" content="Portfolio de Steven YAMBOS, Développeur Back-End avec 5 ans d'expérience spécialisé en C# .NET. APIs REST, microservices, Clean Architecture, PostgreSQL, AWS. Basé à Paris." />
        <meta property="og:title" content="Steven YAMBOS — Développeur Back-End C# .NET" />
        <meta property="og:description" content="Portfolio de Steven YAMBOS, Développeur Back-End avec 5 ans d'expérience spécialisé en C# .NET. APIs REST, microservices, Clean Architecture. Basé à Paris." />
        <meta property="og:url" content="https://stevenyambos.fr" />
      </Helmet>
      <main>
        <HeroSection />
        <ProjectsSection />
        <SkillsSection />
        <BlogSection />
        <GitHubSection />
      </main>
    </>
  )
}

/*
 * App
 * ──────────────────────────────────────────────
 * Routes déclarées :
 *   /             → page d'accueil
 *   /blog         → liste des articles
 *   /blog/:slug   → détail d'un article
 *   /contact      → formulaire de contact
 *
 * Header et Footer sont toujours rendus,
 * quelle que soit la route active.
 */
function App() {
  return (
    <>
      {/* Navigation principale — persistante */}
      <Header />

      <Routes>
        {/* Accueil */}
        <Route path="/" element={<HomePage />} />

        {/* Blog — liste paginée avec filtres */}
        <Route path="/blog" element={<BlogPage />} />

        {/* Article — détail via slug */}
        <Route path="/blog/:slug" element={<ArticleDetailPage />} />

        {/* Contact */}
        <Route path="/contact" element={<ContactPage />} />

        {/* Auth pages */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/create-article" element={<CreateArticlePage />} />
        <Route path="/admin/edit-article/:id" element={<EditArticlePage />} />
        <Route path="/account" element={<AccountPage />} />
      </Routes>

      {/* Pied de page — persistant */}
      <Footer />
    </>
  )
}

export default App